import { drupalComponent } from '@nech/src/helpers/drupal-component';

const isMobile = window.innerWidth < 1024;
let lastScrollPosition = 0;

(function (Drupal, $) {
  drupalComponent('nechSummary', {
    selector: '.summary',

    shared: {
      isScrollingToTarget: false,

      slugify: function (text: string) {
        return text
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^\p{L}\p{N}]+/gu, '-')
          .replace(/^-+|-+$/g, '')
          .toLowerCase();
      },

      isSafeId: function (id: string) {
        return /^[A-Za-z][A-Za-z0-9_-]*$/.test(id);
      },

      createValidId: function (text: string, usedIds: Set<string>) {
        const base = this.slugify(text) || 'section';
        let id = base;
        let suffix = 2;

        while (usedIds.has(id)) {
          id = `${base}-${suffix}`;
          suffix += 1;
        }

        usedIds.add(id);

        return id;
      },

      toggleItem: function ($el: JQuery<HTMLElement>, forceClose: boolean = false) {
        const content = $el.find('.content');
        const isOpen = !content.hasClass('hidden');

        if (isMobile && (forceClose || isOpen)) {
          $('.content-shadow').css('display', 'none');

          content.css({
            transition: 'height 300ms ease, opacity 300ms ease',
            opacity: 0,
            height: 0,
          });

          setTimeout(() => {
            content.addClass('hidden');
            content.css('display', 'none');
          }, 400);

          $('.button-summary').css('transform', 'rotate(180deg)');
          return;
        }

        if (isMobile && !isOpen) {
          $('.content').not(content).slideUp(400).addClass('hidden');
          $('.button-summary').css('transform', 'rotate(180deg)');

          $('.content-shadow').css('display', 'block');

          content.removeClass('hidden').css({
            display: 'block',
            opacity: 0,
            height: 'auto',
          });

          const height = content.outerHeight() || 0;
          content.css({
            height: 0,
            opacity: 0,
            transition: 'height 300ms ease, opacity 300ms ease',
          });

          // Force reflow
          const _ = content[0]?.offsetHeight;

          content.css({
            height: height,
            opacity: 1,
          });

          const icon = $el.find('.button-summary');
          icon.css('transform', 'rotate(0deg)');
        }
      },

      closeMenu: function ($el: JQuery<HTMLElement>, forceClose: boolean = false) {
        const content = $el.find('.content');
        const isOpen = !content.hasClass('hidden');

        if (isMobile && (forceClose || isOpen)) {
          $('.content-shadow').css('display', 'none');

          content.css({
            transition: 'height 300ms ease, opacity 300ms ease',
            opacity: 0,
            height: 0,
          });

          setTimeout(() => {
            content.addClass('hidden');
            content.css('display', 'none');
          }, 400);

          $('.button-summary').css('transform', 'rotate(180deg)');
          return;
        }
      },

      scrollToTarget: function (targetElement: JQuery<HTMLElement>) {
        if (targetElement.length) {
          this.isScrollingToTarget = true;
          const currentScrollPosition = $(window).scrollTop() || 0;
          const summaryHeight = $('.summary').outerHeight();
          const targetPosition = targetElement.offset()?.top || 0;
          const isScrollDown = targetPosition - 300 > currentScrollPosition;
          lastScrollPosition = currentScrollPosition;
          let spacingValueAdding: number = 0;

          if (isMobile && !isScrollDown) {
            spacingValueAdding = 90;
          } else if (!isMobile && !isScrollDown) {
            spacingValueAdding = 110;
          } else if (isScrollDown && isMobile) {
            spacingValueAdding = 10;
          } else {
            spacingValueAdding = 20;
          }

          const headerHeight =
            isMobile && summaryHeight ? summaryHeight + spacingValueAdding : spacingValueAdding;
          const scrollPosition = targetPosition - headerHeight;

          $('html, body').animate(
            {
              scrollTop: scrollPosition,
            },
            {
              duration: 500,
              complete: () => {
                const finalPosition = targetElement.offset()?.top || 0;
                const currentScroll = $(window).scrollTop() || 0;
                const expectedPosition = currentScroll + headerHeight;

                if (Math.abs(finalPosition - expectedPosition) > 0) {
                  $('html, body').animate(
                    {
                      scrollTop: finalPosition - headerHeight,
                    },
                    200,
                    () => {
                      this.isScrollingToTarget = false;
                      this.updateActiveLink($('.summary'));
                    },
                  );
                } else {
                  this.isScrollingToTarget = false;
                  this.updateActiveLink($('.summary'));
                }
              },
            },
          );
        }
      },

      scrollToHash: function () {
        const hash = window.location.hash.replace(/^#/, '');

        if (!hash) {
          return;
        }

        const target = document.getElementById(decodeURIComponent(hash));

        if (target) {
          this.scrollToTarget($(target));
        }
      },

      generateLabels: function ($el: JQuery<HTMLElement>) {
        $el.find('.content').empty();
        const self = this;
        const h2Titles = $('.standard').find('h2');
        const fragment = $(document.createDocumentFragment());
        const usedIds = new Set<string>();

        h2Titles.each(function () {
          const h2Text = $(this).text();
          if (h2Text.length === 0) {
            return;
          }

          const existingId = $(this).attr('id');
          let h2Id: string;

          if (existingId && self.isSafeId(existingId) && !usedIds.has(existingId)) {
            h2Id = existingId;
            usedIds.add(h2Id);
          } else {
            h2Id = self.createValidId(h2Text, usedIds);
            $(this).attr('id', h2Id);
          }

          let listItem: JQuery<HTMLElement>;
          const mobileIcon: JQuery<HTMLElement> = $(
            '<span class="ph ph-arrow-down-right text-primary-700" style="margin-left: auto;"></span>',
          );

          if (isMobile) {
            listItem = $(
              '<li class="py-4 relative px-5 bg-neutral-100 lg:bg-primary-700 lg:gap-4 lg:px-0 lg:pt-6 lg:pb-0 border-b-solid border-b-[1px] border-b-neutral-200"></li>',
            );
          } else {
            listItem = $(
              '<li class="py-4 relative px-5 bg-neutral-100 lg:bg-primary-700 lg:gap-4 lg:px-0 lg:pt-6 lg:pb-0"></li>',
            );
          }

          const label = $('<p></p>').addClass('label-s lg:heading-xxs').text(h2Text);
          const link = $('<a></a>')
            .attr('href', `#${h2Id}`)
            .attr('aria-label', `Aller au contenu de la page ${h2Text}`)
            .css({
              position: 'absolute',
              inset: '0',
            })
            .on('click', function (e) {
              e.preventDefault();
              e.stopPropagation();

              $el.find('.content a').removeClass('active');
              $(this).addClass('active');

              if (window.history && window.history.pushState) {
                window.history.pushState(null, '', `#${h2Id}`);
              }
              const targetElement = document.getElementById(h2Id);
              if (targetElement) {
                self.scrollToTarget($(targetElement));
              }
            })
            .on('mouseenter', function () {
              label.addClass('underline');
            })
            .on('mouseleave', function () {
              label.removeClass('underline');
            });

          listItem.append(link);
          listItem.append(label);
          if (isMobile) {
            listItem.append(mobileIcon);
          }
          fragment.append(listItem);
        });

        $el.find('.content').append(fragment);
        this.updateActiveLink($el);
        $(window).on('scroll', () => this.updateActiveLink($el));
      },

      updateActiveLink: function ($el: JQuery<HTMLElement>) {
        const documentHeight = $(document).height() || 0;
        const windowHeight = $(window).height() || 0;
        const summaryHeight = $('.summary').outerHeight();
        const h2Elements = $('.standard').find('h2');
        const lastH2 = h2Elements.last();
        const firstH2 = h2Elements.first();
        const scrollTop = $(window).scrollTop() || 0;
        const headerHeight = isMobile && summaryHeight ? summaryHeight + 150 : 150;
        let activeSection: any;
        const contentWrapper = $('.standard-el');
        if (this.isScrollingToTarget) return;
        if (h2Elements.length === 0) {
          $el.addClass('hidden');
        } else {
          $el.removeClass('hidden');
          contentWrapper.addClass('m-5 border border-neutral-200 lg:m-0');
          if (window.innerWidth >= 1024) {
            contentWrapper.css({
              'border-left-radius': '0px',
              'border-top-right-radius': '16px',
              'border-bottom-right-radius': '16px',
            });
          } else {
            contentWrapper.css({
              'border-top-left-radius': '0px',
              'border-top-right-radius': '0px',
              'border-bottom-radius': '16px',
            });
          }
        }

        const firstH2Offset = firstH2.offset();
        if (
          firstH2Offset &&
          scrollTop + headerHeight < firstH2Offset.top + (firstH2.outerHeight() || 0)
        ) {
          activeSection = firstH2;
        } else if (scrollTop + windowHeight >= documentHeight) {
          activeSection = lastH2;
        } else {
          // Sinon, parcours normal
          h2Elements.each(function () {
            const $h2 = $(this) as JQuery<HTMLElement>;
            const offset = $h2.offset();

            if (offset && offset.top + ($h2.outerHeight() ?? 0) > scrollTop + headerHeight) {
              return false; // Stop la boucle
            }

            if (offset && offset.top <= scrollTop + headerHeight) {
              activeSection = $h2;
            } else if (
              lastH2.length &&
              lastH2.offset()?.top !== undefined &&
              scrollTop + 400 >= lastH2.offset()!.top
            ) {
              activeSection = lastH2;
            }
          });
        }

        $el.find('.content a').removeClass('active');
        if (activeSection) {
          const h2Id = activeSection.attr('id');
          $el.find(`.content a[href="#${h2Id}"]`).addClass('active');
        }
      },
    },

    attach(context, options) {
      const self = this;
      const $elements = $(this.selector, context);

      $elements.each(function () {
        const $el = $(this);

        self.shared.generateLabels($el);

        self.shared.scrollToHash();
        $(window).on('hashchange', function () {
          self.shared.scrollToHash();
        });

        $el.find('.summary-title, .button-summary').on('click', function (event) {
          event.stopPropagation();
          self.shared.toggleItem($el);
        });

        const $content = $el.find('.content');
        const liLastChild = $el.find('ol li:last-child');

        $('.summary').css('position', 'sticky');

        if ($content && ($content.outerHeight() as number) >= 364) {
          const $contentShadow = $("<div class='content-shadow'></div>");
          $('.summary').append($contentShadow);
        }

        let lastScrollTop = 0;
        $(window).on('scroll', function () {
          const scrollTop = $(this).scrollTop() as number;

          if (scrollTop < lastScrollTop && isMobile) {
            $('.summary').css('top', '69px');
          } else if (scrollTop < lastScrollTop && !isMobile) {
            $('.summary').css('top', '110px');
          } else {
            $('.summary').css('top', '0px');
          }
          lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
        });

        $content.on('scroll', function (e) {
          const clientHeight = (e.target as HTMLElement).clientHeight;
          const $contentShadow = $('.content-shadow');

          if (liLastChild.position().top - 20 <= clientHeight) {
            $contentShadow.css('display', 'none');
          } else {
            $contentShadow.css('display', 'block');
          }
        });

        $(document).on('click', function (event) {
          const $target = $(event.target);

          if ($target.is('a') || $target.closest('a').length) {
            return;
          }

          event.stopPropagation();
          self.shared.closeMenu($el);
        });
      });
    },
  });
})(Drupal, jQuery);
